import { Listing } from 'ha/services/apiV2/types/Listing';
import { MakeCall } from 'ha/services/apiV2/createMakeCall';

export type CreateListingPayload = Pick<
  Listing,
  'address' | 'currency' | 'kind' | 'price' | 'type' | 'minimumStayMonths'
>;

export default (makeCall: MakeCall) =>
  ({
    address,
    currency,
    kind,
    price,
    type,
    minimumStayMonths,
  }: CreateListingPayload) =>
    makeCall<Listing>('POST', `/api/v2/listing`, {
      data: {
        address,
        currency,
        kind,
        minimumStayMonths,
        price,
        type,
      },
    });
